

function updateCartProgress() {

  const stepValues = [1000, 2500, 4500];
  const stepMessages = ["5% OFF", "10% OFF", "15% OFF"];

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const fill = document.querySelector(".progress-fill");
      const steps = document.querySelectorAll(".step");
      const message = document.querySelector(".progress-message");

      if (!fill) return;

      let cartTotal = cart.total_price / 100;
      let maxValue = stepValues[stepValues.length - 1];

      // Progress %
      let percent = (cartTotal / maxValue) * 100;
      if (percent > 100) percent = 100;

      fill.style.width = percent + "%";

      // Activate steps
      steps.forEach((step, index) => {
        step.classList.remove("active");
        if (cartTotal >= stepValues[index]) {
          step.classList.add("active");
        }
      });

      // 🔥 Dynamic message logic
      if (cartTotal < stepValues[0]) {
        let remaining = stepValues[0] - cartTotal;
        message.innerHTML = `₹${remaining} away from ${stepMessages[0]}`;
      }
      else if (cartTotal < stepValues[1]) {
        let remaining = stepValues[1] - cartTotal;
        message.innerHTML = `₹${remaining} away from ${stepMessages[1]}`;
      }
      else if (cartTotal < stepValues[2]) {
        let remaining = stepValues[2] - cartTotal;
        message.innerHTML = `₹${remaining} away from ${stepMessages[2]}`;
      }
      else {
        message.innerHTML = `🎉 You unlocked all offers!`;
      }

    });
}

document.addEventListener("DOMContentLoaded", function () {

  updateCartProgress();

  // 🔥 Observe cart drawer DOM changes
  const cartDrawer = document.querySelector(".popup-cart");

  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      updateCartProgress();
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

});